'use strict';

import FormHelpers from '../util/form';
import { continueButtonToggle, paypalUtilsInit, paypalMFRAInit } from './paypal';
import {
    newModalFromString
} from '../components/modal';
import { applyRendering } from '../util/render';

var addressHelpers = require('./address');


/**
 * updates the billing address selector within billing forms
 * @param {Object} order - the order model
 * @param {Object} customer - the customer model
 */
function updateBillingAddressSelector (order, customer) {
    var shippings = order.shipping;

    var form = $('form[name$=billing]')[0];
    var $billingAddressSelector = $('.addressSelector', form);
    var hasSelectedAddress = false;

    if ($billingAddressSelector && $billingAddressSelector.length === 1) {
        $billingAddressSelector.empty();
        // Add New Address option
        $billingAddressSelector.append(addressHelpers.methods.optionValueForAddress(
            null,
            false,
            order, {
                type: 'billing'
            }));

        var hasSetShippingAddress = true;
        shippings.forEach(function (aShipping) {
            // the shipping address "store" should not be selectable as billing + pickup point
            if (aShipping.selectedShippingMethod.storePickupEnabled || ('pointPickupEnabled' in aShipping.selectedShippingMethod && aShipping.selectedShippingMethod.pointPickupEnabled)) {
                hasSetShippingAddress = false;
                return;
            }
        });
        if (hasSetShippingAddress) {
            // Separator -
            $billingAddressSelector.append(addressHelpers.methods.optionValueForAddress(
                order.resources.shippingAddresses, false, order, {
                    // className: 'multi-shipping',
                    type: 'billing'
                }
            ));
        }

        shippings.forEach(function (aShipping) {
            // the shipping address "store" should not be selectable as billing
            if (aShipping.selectedShippingMethod.storePickupEnabled || ('pointPickupEnabled' in aShipping.selectedShippingMethod && aShipping.selectedShippingMethod.pointPickupEnabled)) {
                return;
            }
            var isSelected = order.billing.matchingAddressId === aShipping.UUID;
            hasSelectedAddress = hasSelectedAddress || isSelected;
            // Shipping Address option
            $billingAddressSelector.append(
                addressHelpers.methods.optionValueForAddress(aShipping, isSelected, order, {
                    // className: 'multi-shipping',
                    type: 'billing'
                })
            );
        });

        if (customer.addresses && customer.addresses.length > 0) {
            $billingAddressSelector.append(addressHelpers.methods.optionValueForAddress(
                order.resources.accountAddresses, false, order));
            customer.addresses.forEach(function (address) {
                var isSelected = order.billing.matchingAddressId === address.ID;
                hasSelectedAddress = hasSelectedAddress || isSelected;
                // Customer Address option
                $billingAddressSelector.append(
                    addressHelpers.methods.optionValueForAddress({
                        UUID: 'ab_' + address.ID,
                        shippingAddress: address
                    }, isSelected, order, {
                        type: 'billing'
                    })
                );
            });
        }
    }

    if (hasSelectedAddress) {
        // (!order.billing.matchingAddressId && order.billing.billingAddress.address)) {
        // show
        $(form).attr('data-address-mode', 'edit');
    } else {
        $(form).attr('data-address-mode', 'new');
    }

    $billingAddressSelector.show();
}

/**
 * updates the billing address form values within payment forms
 * @param {Object} order - the order model
 */
function updateBillingAddressFormValues (order) {
    var billing = order.billing;
    if (!billing.billingAddress || !billing.billingAddress.address) return;

    var form = $('form[name=dwfrm_billing]');
    if (!form) return;

    $('#billingOriginalValues').val(JSON.stringify(billing.billingAddress.address));

    $('input[name$=_firstName]', form).val(billing.billingAddress.address.firstName);
    $('input[name$=_lastName]', form).val(billing.billingAddress.address.lastName);
    $('input[name$=_address1]', form).val(billing.billingAddress.address.address1);
    $('input[name$=_address2]', form).val(billing.billingAddress.address.address2);
    $('input[name$=_city]', form).val(billing.billingAddress.address.city);
    $('input[name$=_postalCode]', form).val(billing.billingAddress.address.postalCode);
    $('select[name$=_stateCode],input[name$=_stateCode]', form)
        .val(billing.billingAddress.address.stateCode)
        .trigger('chosen:updated');
    $('select[name$=_country]', form).val(billing.billingAddress.address.countryCode.value)
        .trigger('chosen:updated');
    $('input[name$=_phone]', form).val(billing.billingAddress.address.phone);
    $('input[name$=_email]', form).val(order.orderEmail);

    $('.billingFirstName').val(billing.billingAddress.address.firstName);
    $('.billingLastName').val(billing.billingAddress.address.lastName);
    $('.billingAddressOne').val(billing.billingAddress.address.address1);
    $('.billingAddressTwo').val(billing.billingAddress.address.address2);
    $('.billingAddressCity').val(billing.billingAddress.address.city);
    $('.billingState').val(billing.billingAddress.address.stateCode);
    $('.billingZipCode').val(billing.billingAddress.address.postalCode);
    $('.billingCountry').val(billing.billingAddress.address.countryCode.value);

    var street = billing.billingAddress.address.address1;
    if (street) {
        var splittedInfo = street.split(/([0-9]+)/);
        $('#streetName', form).val(splittedInfo[0].trim());
        $('#streetNumber', form).val((splittedInfo[1] || '').trim());
    }
}

/**
 * clears the billing address form values
 */
function clearBillingAddressFormValues () {
    updateBillingAddressFormValues({
        billing: {
            billingAddress: {
                address: {
                    countryCode: {}
                }
            }
        }
    });
}

/**
 * updates the basket with COD fee
 */
function updateTotalPaymentSelection ($drawer) {
    FormHelpers.clearPreviousErrors('.payment-form');
    const $paymentForm = $('#dwfrm_billing');
    var paymentForm = $paymentForm.serialize();

    $('body').trigger('checkout:serializeBilling', {
        form: $('#dwfrm_billing'),
        data: paymentForm,
        callback: function (data) {
            paymentForm = data;
        }
    });
    $.spinner().start();
    $.ajax({
        url: $('#dwfrm_billing').attr('data-update-total-payment-url'),
        method: 'POST',
        data: paymentForm,
        success: function (data) {
            $.spinner().stop();
            // look for field validation errors
            if (data.error) {
                if (data.cartError) {
                    window.location.href = data.redirectUrl;
                } else if ('fieldErrors' in data && data.fieldErrors.length) {
                    data.fieldErrors.forEach(function (error) {
                        if (Object.keys(error).length) {
                            FormHelpers.loadFormErrors('.payment-form', error);
                        }
                    });
                } else if ('serverErrors' in data && data.serverErrors.length) {
                    data.serverErrors.forEach(function (error) {
                        $('.error-message.payment')
                            .show()
                            .find('.error-message-text')
                            .text(error);
                    });
                } else if ('paymentCardError' in data && data.paymentCardError) {
                    $drawer.find('.multipayment-promo-error-message').removeClass('hidden').text(data.paymentCardError);
                    $drawer.find('.drawer-content input, textarea, select')
                        .not('[name="consPsonalizedNews"]')
                        .attr('disabled', 'disabled');
                    $drawer.find('.policy-promotion-payment').addClass('policy-promotion-payment-disabled');
                }
            } else {
                $('body').trigger('checkout:updateCheckoutView', {
                    order: data.order,
                    customer: data.customer,
                    action: data.action
                });
                if (data.paymentMethodID === 'CONTRASSEGNO') {
                    $('#dwfrm_billing').attr('data-total-updated', true);
                } else {
                    $('#dwfrm_billing').attr('data-total-updated', false);
                }

                // Avoid showing saved PayPal account once recurrent user update his payment method selection
                if (data.paymentMethodID === 'PayPal' && $('.paypal-use-saved-method-checkbox').length && $('.paypal-use-saved-method-checkbox').is(':checked')) {
                    $('.paypal-use-saved-method-checkbox').trigger('click');
                }
                // Avoid showing saved PayPal account in case of "already handled token"
                if (data.paymentMethodID === 'PayPal' && $('.paypal-use-another-account-checkbox').length && !$('.paypal-use-another-account-checkbox').is(':checked')) {
                    $('.paypal-use-another-account-checkbox').trigger('click');
                }
            }
        },
        error: function () {
            $.spinner().stop();
        }
    });
}

// Populate Billing Summary
function populateBillingAddressSummary (parentSelector, address, customer) {
    if (parseInt($('.billingIsAvailable').val()) === 0) {
        // $('div, span', parentSelector).text('');
        $('.summary-details.billing').addClass('hidden');
        return;
    }
    // Removing 'ind-fatt' like this is meant to be a temporary solution.
    // 'invoiceFlag', which sets this class, has a value of 'false', first time in a payment stage, even when 'billInDifferentAddress' is checked.
    // This flag is written for a checkout confirmation page. However the same template is present in checkout, payment stage.
    $('.summary-details.billing').removeClass(['hidden', 'ind-fatt']);

    $.each(address, function (attr) {
        var val = address[attr];
        $('.' + attr, parentSelector).text(val || '');
    });
}

/**
 * Updates the billing information in checkout, based on the supplied order model
 * @param {Object} order - checkout model to use as basis of new truth
 * @param {Object} customer - customer model to use as basis of new truth
 * @param {Object} [options] - options
 */
function updateBillingInformation (order, customer, option, action) {
    updateBillingAddressSelector(order, customer);

    // update billing address form
    updateBillingAddressFormValues(order);

    // update billing address summary
    var form = $('form[name=dwfrm_shipping]');

    let legalPerson = parseInt($('.billingLegalPerson').val()) === 1;
    let addressWithCustomerElements = {
        ...order.billing.billingAddress.address,
        VATNumber: legalPerson ? $('input[name$=_VATNumber]', form).val() : '',
        pecEmailAddress: legalPerson ? $('input[name$=_pecEmailAddress]', form).val() : '',
        sdi: legalPerson ? $('input[name$=_sdi]', form).val() : '',
        companyName: legalPerson ? $('input[name$=_companyName]', form).val() : '',
        fiscalCode: !legalPerson ? $('input[name$=_fiscalCode]', form).val() : '',
        CompanyIdentificationNumber: legalPerson ? $('input[name$=_CompanyIdentificationNumber]', form).val() : ''
    };
    populateBillingAddressSummary('.billing .address-summary', addressWithCustomerElements);

    // update billing parts of order summary
    $('.order-summary-email').text(order.orderEmail);

    if (order.billing.billingAddress.address) {
        $('.order-summary-phone').text(order.billing.billingAddress.address.phone);
    }
/*
    if (action) {
        return;
    }
    $('body').trigger('address:submitFromCheckout'); */
}

/**
 * Updates the payment information in checkout, based on the supplied order model
 * @param {Object} order - checkout model to use as basis of new truth
 */
function updatePaymentInformation (order, options, action) {
    // update payment details
    var $paymentSummary = $('.payment-details');
    var htmlToAppend = '';

    if (order.billing.payment && order.billing.payment.selectedPaymentInstruments &&
        order.billing.payment.selectedPaymentInstruments.length > 0) {
        for (let i = 0; i < order.billing.payment.selectedPaymentInstruments.length; i++) {
            var currentPaymentInstrument = order.billing.payment.selectedPaymentInstruments[i];
            switch (currentPaymentInstrument.paymentMethod) {
            case 'CREDIT_CARD' :
                var data = {
                    maskedNumber: currentPaymentInstrument.maskedCreditCardNumber,
                    image: currentPaymentInstrument.cardTypeImage.src,
                    alt: currentPaymentInstrument.cardTypeImage.alt
                };
                if (currentPaymentInstrument.creditCardType) {
                    data.type = currentPaymentInstrument.creditCardType;
                    data.holder = currentPaymentInstrument.creditCardHolder;
                } else if (currentPaymentInstrument.type) {
                    data.type = currentPaymentInstrument.type;
                    data.holder = currentPaymentInstrument.owner;
                }
                htmlToAppend += applyRendering('creditCardSummaryTemplate', data);
                break;
            case 'PayPal' :
                htmlToAppend += applyRendering('paypalSummaryTemplate', {
                    paymentMethod: currentPaymentInstrument.paymentMethod || '',
                    email: currentPaymentInstrument.paypalEmail || ''
                });
                break;
            case 'AMAZONPAY' :
                htmlToAppend += applyRendering('amazonpaySummaryTemplate', {
                    paymentMethod: currentPaymentInstrument.paymentMethod || ''
                });
                break;
            case 'GOOGLEPAY' :
                htmlToAppend += applyRendering('googlepaySummaryTemplate', {
                    paymentMethod: currentPaymentInstrument.paymentMethod || ''
                });
                break;
            case 'DW_APPLE_PAY' :
                htmlToAppend += `<span>Apple Pay</span>`;
                break;
            case 'KLARNA_PAYMENTS' :
                htmlToAppend = applyRendering('klarnaSummaryTemplate', {
                    paymentMethod: currentPaymentInstrument.paymentMethod || '',
                    isKlarnaExpress: true
                });
                break;
            default :
                htmlToAppend += `<span>${currentPaymentInstrument.paymentMethod}</span>`;
            }
        }
    }
    if (currentPaymentInstrument && currentPaymentInstrument.paymentMethod === 'KLARNA_PAYMENTS' && action === 'payment'){
        return;
    }
    if (order.billing.payment && order.billing.payment.applicablePaymentMethods) {
        $('[data-method-id]').hide();
        const selectedMethod = $('[data-method-id] input[name="dwfrm_billing_paymentMethod"]:checked').attr('id');

        // See explanation in assets/scripts/billing.js (commit f1fb2ce4)
        $('[data-method-id] input[name="dwfrm_billing_paymentMethod"]').prop('checked', false);

        for (let i = 0; i < order.billing.payment.applicablePaymentMethods.length; i++) {
            const methodID = order.billing.payment.applicablePaymentMethods[i].ID;
            $(`[data-method-id="${methodID}"]`).show();

            if (methodID === selectedMethod) {
                $(`[data-method-id="${methodID}"] input[name="dwfrm_billing_paymentMethod"]`).prop('checked', true);
            }
            if (methodID === 'CREDIT_CARD' && selectedMethod === 'CREDIT_CARD_AMEX') {
                $(`[data-method-id="CREDIT_CARD"] input[name="dwfrm_billing_paymentMethod"]`).prop('checked', false);
                $(`[data-method-id="CREDIT_CARD_AMEX"] input[name="dwfrm_billing_paymentMethod"]`).prop('checked', true);
            }
            if (methodID === 'CREDIT_CARD') {
                $(`[data-method-id="${methodID}_AMEX"]`).show();
            }
            if (methodID === 'KLARNA_PAYMENTS') {
                $('#' + selectedMethod).prop('checked', true);
            }
            if (methodID === 'CONTRASSEGNO') {
                var isBopis = $('.store-info').hasClass('is-bopis');
                var isOneSplice = $('.checkout-product-summary-dispo').length < 2;
                $(`[data-method-id="${methodID}"]`)[(!isBopis && isOneSplice) ? 'show' : 'hide']();
            }
        }
    }

    $paymentSummary.empty().append(htmlToAppend);
}

/**
 * clears the credit card form
 */
function clearCreditCardForm () {
    $('input[name$="_cardNumber"]').data('cleave').setRawValue('');
    $('select[name$="_expirationMonth"]').val('');
    $('select[name$="_expirationYear"]').val('');
    $('input[name$="_securityCode"]').val('');
    $('input[name$="_email"]').val('');
    // $('input[name$="_phone"]').val('');
}

module.exports = {
    methods: {
        updateBillingAddressSelector: updateBillingAddressSelector,
        updateBillingAddressFormValues: updateBillingAddressFormValues,
        clearBillingAddressFormValues: clearBillingAddressFormValues,
        updateBillingInformation: updateBillingInformation,
        updatePaymentInformation: updatePaymentInformation,
        clearCreditCardForm: clearCreditCardForm
    },

    showBillingDetails: function () {
        $('.btn-show-billing-details').on('click', function () {
            $(this).parents('[data-address-mode]').attr('data-address-mode', 'new');
        });
    },

    hideBillingDetails: function () {
        $('.btn-hide-billing-details').on('click', function () {
            $(this).parents('[data-address-mode]').attr('data-address-mode', 'shipment');
        });
    },

    selectBillingAddress: function () {
        $('.payment-form .addressSelector').on('change', function () {
            var form = $(this).parents('form')[0];
            var selectedOption = $('option:selected', this);
            var optionID = selectedOption[0].value;

            if (optionID === 'new') {
                // Show Address
                $(form).attr('data-address-mode', 'new');
            } else {
                // Hide Address
                $(form).attr('data-address-mode', 'shipment');
            }

            // Copy fields
            var attrs = selectedOption.data();
            var element;

            Object.keys(attrs).forEach(function (attr) {
                element = attr === 'countryCode' ? 'country' : attr;
                if (element === 'cardNumber') {
                    $('.cardNumber').data('cleave').setRawValue(attrs[attr]);
                } else {
                    $('[name$=' + element + ']', form).val(attrs[attr]);
                }
            });
        });
    },

    handlePayPalConsent: function () {
        const $paypalWrap = $('.js_paypal_button_on_billing_form').parent();
        $paypalWrap.on('click', (e) => {
            $('#dwfrm_billing').parsley().destroy();
            $('#dwfrm_billing').parsley({excluded: '#cardNumber,#expirationMonth,#expirationYear,#securityCode,#billingIsAvailable,[disabled]'}).validate();
        });
    },

    handleGooglePayConsent: function () {
        const $googleWrap = $('.js-google-pay-button-on-billing-form').parent();
        $googleWrap.on('click', (e) => {
            $('#dwfrm_billing').parsley().destroy();
            $('#dwfrm_billing').parsley({excluded: '#cardNumber,#expirationMonth,#expirationYear,#securityCode,#billingIsAvailable,[disabled]'}).validate();
        });
    },

    handleCreditCardNumber: function () {
        try {
            FormHelpers.handleCreditCardNumber('.cardNumber', '#cardType');
            FormHelpers.handleAmexNumber('.cardNumberAmex', '#cardType');
        } catch (e) {
            // in dev might give errors if gestpay is not properly configured
        }
    },

    santitizeForm: function () {
        $('body').on('checkout:serializeBilling', function (e, data) {
            let isAmexSelected = $('#CREDIT_CARD_AMEX:checked').length > 0;
            var serializedForm = FormHelpers.serializeData(data.form, isAmexSelected);

            data.callback(serializedForm);
        });
    },

    updateDrawer: function () {
        $('body').on('change', 'input[name$="paymentMethod"]', function (e) {
            const $drawer = $(e.currentTarget).closest('.drawer');
            const $currentTabContent = $drawer.find('.drawer-content');

            // Disabled all other drawers and their inputs, except Gift Card
            var $otherDrawers = $('.drawer').not($drawer).not('.giftCardDrawer');
            if ($('.giftCardDrawer').length && $('.giftCardDrawer .buttonRemoveGiftcard').hasClass('hide')) {
                $otherDrawers = $('.drawer').not($drawer);
            }

            if ($otherDrawers && $otherDrawers.length && $($otherDrawers[0]).hasClass('giftCardDrawer')) {
                $('#giftCardContainer').prop('checked', false);
            }
            $otherDrawers.removeClass('active');
            $otherDrawers.find('.drawer-content input, textarea, select')
                .not('[name="consPsonalizedNews"]')
                .attr('disabled', 'disabled');
            $otherDrawers.find('.multipayment-promo-error-message').addClass('hidden');
            $otherDrawers.find('.policy-promotion-payment').removeClass('policy-promotion-payment-disabled');
            // Reset all other T&C inputs
            $otherDrawers.find('.policy-promotion-payment input')
                .prop('checked', false);

            // Enable the current drawer's inputs
            $drawer.find('.drawer-content input, textarea, select')
                .not('[name="consPsonalizedNews"]')
                .removeAttr('disabled', 'disabled');

            const methodID = $drawer.data('method-id');
            $('.payment-information').data('payment-method-id', methodID);
            $drawer.addClass('active');

            // Disable Continue Checkout button if payment method is PayPal
            if ($currentTabContent.find('.js_paypal_button_on_billing_form').length) {
                continueButtonToggle(!$currentTabContent.find('.paypal-content').data('paypalIsHideContinueButton'));
                $('.js_paypal_button_on_billing_form').toggleClass('disabled', true);
            } else {
                continueButtonToggle(true);
            }

            $('.klarna-info-note').addClass('hidden');
            $('[name="legalPersonVisible"]').prop('disabled', false);

            var form = $('form[name=dwfrm_billing]');
            $('input[name$=_firstName]', form).prop('disabled', false);
            $('input[name$=_lastName]', form).prop('disabled', false);
            $('input[name$=_address1]', form).prop('disabled', false);
            $('input[name$=_address2]', form).prop('disabled', false);
            $('input[name$=_city]', form).prop('disabled', false);
            $('input[name$=_postalCode]', form).prop('disabled', false);
            $('select[name$=_stateCode],input[name$=_stateCode]', form)
                .prop('disabled', false);
            $('select[name$=_country]', form).prop('disabled', false);

            if (methodID === 'CREDIT_CARD_AMEX') {
                $('[data-method-id="CREDIT_CARD"] .drawer-content').find('input,select').prop('disabled', true);
                $drawer.find('input,select').prop('disabled', false);
            } else if (methodID === 'CREDIT_CARD') {
                $('[data-method-id="CREDIT_CARD_AMEX"] .drawer-content').find('input,select').prop('disabled', true);
                $drawer.find('input,select').prop('disabled', false);
            }

            updateTotalPaymentSelection($drawer);

            if (methodID === 'KLARNA') {
                $('.klarna-info-note').removeClass('hidden');
                $('#billingLegalPersonPrivate').trigger('click');
                $('[name="legalPersonVisible"]').prop('disabled', true);

                const originalBilling = JSON.parse($('#billingOriginalValues').val() || '{}');
                updateBillingAddressFormValues({billing: {
                    billingAddress: {
                        address: originalBilling
                    }
                }});

                $('input[name$=_firstName]', form).prop('disabled', true);
                $('input[name$=_lastName]', form).prop('disabled', true);
                $('input[name$=_address1]', form).prop('disabled', true);
                $('input[name$=_address2]', form).prop('disabled', true);
                $('input[name$=_city]', form).prop('disabled', true);
                $('input[name$=_postalCode]', form).prop('disabled', true);
                $('select[name$=_stateCode],input[name$=_stateCode]', form)
                    .prop('disabled', true);
                $('select[name$=_country]', form).prop('disabled', true);
            }

            const isGiftCardChecked = $('input[name$="giftCardContainer"]').prop('checked');
            if (!isGiftCardChecked) {
                $('.drawer[data-method-id="CONTRASSEGNO"]').removeClass('hidden-for-mp');
                $('.drawer[data-method-id="COD"]').removeClass('hidden-for-mp');
                $('.drawer[data-method-id="S2PKLA"]').removeClass('hidden-for-mp');
                $('.drawer[data-method-id="KLARNA"]').removeClass('hidden-for-mp');
                $('.drawer[data-method-id="KLARNA_PAYMENTS"]').removeClass('hidden-for-mp');
                $('.drawer[data-method-id="AFTERPAY_PBI"]').removeClass('hidden-for-mp');
                $('.drawer[data-method-id="PAYPO"]').removeClass('hidden-for-mp');
                $('#giftCardPin').removeClass('hide');
            }
        });
    },

    updateGiftCard: function () {
        $('body').on('change', 'input[name$="giftCardContainer"]', function (e) {
            const isGiftCardChecked = $(e.currentTarget).prop('checked');
            // Enable the current drawer's inputs
            if (isGiftCardChecked) {
                $('.giftCardDrawer').find('.drawer-content input, textarea, select')
                    .not('[name="consPsonalizedNews"]')
                    .removeAttr('disabled', 'disabled');
            } else {
                $('.drawer input[name$="paymentMethod"]').attr('disabled', false);
                // Restore coupon section
                $('.card.coupon-code, .loyalty-coupons-container').removeClass('disabled');
                $('.checkout-applied-giftcard-message').addClass('hide');
            }
            $('.giftCardDrawer').toggleClass('active', isGiftCardChecked);
            $('#giftCardContainer').val($('#giftCardContainer').is(':checked') ? 1 : 0);
            $('.giftcard-checkbalance-success').addClass('hidden');
            $('.giftcard-checkbalance-error').addClass('hidden');
            $('.giftcard-checkbalance-balance-error').addClass('hidden');
            $('.js-check-balance').removeClass('hidden');
            $('.js-check-yourbalance-button').removeClass('hidden');
            $('#giftCardFormGroup .buttonRemoveGiftcard').addClass('hide');
            $('#giftCardFormGroup .buttonApplyGiftcard').removeClass('hide');
            $('.giftCardNumberField, .giftCardPinField').removeClass('giftcardSubmitted');
            $('.giftCardDrawer .giftcard-submit-payment').addClass('hidden');
            $('#giftCardFormGroup .buttonApplyGiftcard').addClass('disabled');
            // Multipayments: Check to enabled/disabled methods in combined with GC
            if (isGiftCardChecked) {
                $('.drawer[data-method-id="CONTRASSEGNO"]').addClass('hidden-for-mp');
                $('.drawer[data-method-id="COD"]').addClass('hidden-for-mp');
                $('.drawer[data-method-id="S2PKLA"]').addClass('hidden-for-mp');
                $('.drawer[data-method-id="KLARNA"]').addClass('hidden-for-mp');
                $('.drawer[data-method-id="KLARNA_PAYMENTS"]').addClass('hidden-for-mp');
                $('.drawer[data-method-id="AFTERPAY_PBI"]').addClass('hidden-for-mp');
                $('.drawer[data-method-id="PAYPO"]').addClass('hidden-for-mp');
                $('#CONTRASSEGNO').prop('checked', false);
                $('#COD').prop('checked', false);
                $('#S2PKLA').prop('checked', false);
                $('#KLARNA').prop('checked', false);
                $('#AFTERPAY_PBI').prop('checked', false);
                $('#PAYPO').prop('checked', false);
                $('.klarna-payment-item').prop('checked', false);
                var recaptchaSiteKey = $('#recaptchaSiteKeyGiftcard').val();
                try {
                    // eslint-disable-next-line no-undef
                    grecaptcha.render('recaptcha', {
                        'sitekey': recaptchaSiteKey,
                        'callback': $('.no-robot').addClass('hidden')
                    });
                } catch (e) {
                    $('.no-robot').removeClass('hidden');
                }
            } else {
                $('.drawer[data-method-id="CONTRASSEGNO"]').removeClass('hidden-for-mp');
                $('.drawer[data-method-id="COD"]').removeClass('hidden-for-mp');
                $('.drawer[data-method-id="S2PKLA"]').removeClass('hidden-for-mp');
                $('.drawer[data-method-id="KLARNA"]').removeClass('hidden-for-mp');
                $('.drawer[data-method-id="KLARNA_PAYMENTS"]').removeClass('hidden-for-mp');
                $('.drawer[data-method-id="AFTERPAY_PBI"]').removeClass('hidden-for-mp');
                $('.drawer[data-method-id="PAYPO"]').removeClass('hidden-for-mp');
                $('.giftCardPinField').removeClass('hide');
            }

            // Multipayments: Call service for recalculate basket
            const $paymentForm = $('#dwfrm_billing');
            var paymentForm = $paymentForm.serialize();
            $.spinner().start();
            $.ajax({
                url: $('.giftCardDrawer').data('remove-giftcard-url'),
                method: 'POST',
                data: paymentForm,
                success: function (data) {
                    // look for field validation errors
                    if (data.error) {
                    } else {
                        $('body').trigger('checkout:updateCheckoutView', {
                            order: data.order,
                            customer: data.customer,
                            action: 'CheckoutServices-UpdateTotalPaymentSelection'
                        });
                        // Clear all previous payment
                        $('.drawer .next-step-button.payment').show();
                        // Reset form except phone number
                        var previousPhoneNumber = $('#phoneNumber').val();
                        $('#dwfrm_billing')[0].reset();
                        $('#phoneNumber').val(previousPhoneNumber);
                        $('.credit-card-drawer input[type="radio"]').prop('checked', false);
                        $('.drawer').removeClass('active');
                        // Re-activate only giftcard section
                        if (isGiftCardChecked) {
                            $('#giftCardContainer').prop('checked', true);
                            $('.drawer.giftCardDrawer').addClass('active');
                        }
                    }
                    $.spinner().stop();
                },
                error: function (err) {
                    if (err.responseJSON.redirectUrl) {
                        window.location.href = err.responseJSON.redirectUrl;
                    }
                    $.spinner().stop();
                }
            });
        });

        $('body').on('click', '#giftCardPane .buttonRemoveGiftcard, .js-edit-order', function (e) {
            var giftCardType = $('input[type="radio"]#giftCardPhysical:checked').length > $('input[type="radio"]#giftCardElectronic:checked').length ? 'Physical' : 'Electronic';
            var gcCode = $('.giftCardDrawer #giftCardNumber').val();
            $('#giftCardContainer').val($('#giftCardContainer').is(':checked') ? 1 : 0);
            $('.giftcard-checkbalance-success').addClass('hidden');
            $('.giftcard-checkbalance-error').addClass('hidden');
            $('.giftcard-checkbalance-balance-error').addClass('hidden');
            $('.js-check-balance').removeClass('hidden');
            $('.js-check-yourbalance-button').removeClass('hidden');
            $('#giftCardFormGroup .buttonRemoveGiftcard').addClass('hide');
            $('#giftCardFormGroup .buttonApplyGiftcard').removeClass('hide');
            $('.giftCardNumberField, .giftCardPinField').removeClass('giftcardSubmitted');
            $('.giftCardDrawer .giftcard-submit-payment').addClass('hidden');
            $('#giftCardFormGroup .buttonApplyGiftcard').addClass('disabled');
            if (giftCardType === 'Electronic') {
                $('.green-check-mark').removeClass('eCard');
                $('.gift-card-number').removeClass('eCard');
                $('.gift-card-number').addClass('physicalCard');
            } else if (giftCardType === 'Physical') {
                $('.green-check-mark').removeClass('physicalCard');
                $('.gift-card-number').removeClass('physicalCard');
                $('.gift-card-number').removeClass('eCard');
                $('.gift-card-number').addClass('physicalCard');
            }

            // Multipayments: Call service for recalculate basket
            const $paymentForm = $('#dwfrm_billing');
            var paymentForm = $paymentForm.serialize();
            $.spinner().start();
            $.ajax({
                url: $('.giftCardDrawer').data('remove-giftcard-url'),
                method: 'POST',
                data: paymentForm,
                success: function (data) {
                    // look for field validation errors
                    if (data.error) {
                    } else {
                        $('body').trigger('checkout:updateCheckoutView', {
                            order: data.order,
                            customer: data.customer,
                            action: data.action,
                            isBopis: data.isBopis
                        });
                        $('body').trigger('checkout:removeGiftCard', {'gcCode': gcCode, 'gcType': giftCardType.toLowerCase()});
                        // Clear all previous payment
                        $('.drawer input[name$="paymentMethod"]').attr('disabled', false);
                        $('.drawer .next-step-button.payment').show();
                        // Reset form except phone number
                        var previousPhoneNumber = $('#phoneNumber').val();
                        $('#dwfrm_billing')[0].reset();
                        $('.drawer').not('.giftCardDrawer').find('.drawer-header input').prop('checked', false);
                        $('#phoneNumber').val(previousPhoneNumber);

                        $('.drawer').removeClass('active');
                        // Re-activate only giftcard section
                        if (giftCardType === 'Electronic') {
                            $('#giftCardPane #giftCardPhysical').trigger('change');
                        }
                        $('#giftCardContainer').prop('checked', true);
                        $('.drawer.giftCardDrawer').addClass('active');
                        $('.giftcard-modal-block').removeClass('hidden');

                        // Restore coupon section
                        $('.card.coupon-code, .loyalty-coupons-container').removeClass('disabled');
                        $('.checkout-applied-giftcard-message').addClass('hide');
                    }
                    $.spinner().stop();
                },
                error: function (err) {
                    if (err.responseJSON.redirectUrl) {
                        window.location.href = err.responseJSON.redirectUrl;
                    }
                    $.spinner().stop();
                }
            });
        });

        $('body').on('change', 'input[name$="giftCardPhysical"]', function (e) {
            const $container = $(e.target).closest('form');
            $('.giftCardPinField', $container).toggleClass('hide');
            $('.giftcard-checkbalance-success').addClass('hidden');
            $('.giftcard-checkbalance-error').addClass('hidden');
            $('.giftcard-checkbalance-balance-error').addClass('hidden');
            $('.js-check-balance').removeClass('hidden');
            $('.js-check-yourbalance-button').removeClass('hidden');
        });

        let modalTriggerId = $('#giftCardBalanceModal').data('trigger-id');
        $('body').on('click', '#' + modalTriggerId, e => {
            e.preventDefault();

            const htmlContent = $('#giftCardBalanceModal').html();

            // create and open confirmation modal
            let modal = newModalFromString(htmlContent, true, [], () => {
                // TODO: On Open Actions
                $('.tingle-modal .close').on('click touchstart', function (e) {
                    e.preventDefault();
                    modal.close();
                });
                var recaptchaSiteKey = $('#recaptchaSiteKeyGiftcard').val();
                try {
                    // eslint-disable-next-line no-undef
                    grecaptcha.render('recaptcha', {
                        'sitekey': recaptchaSiteKey,
                        'callback': $('.no-robot').addClass('hidden')
                    });
                } catch (e) {
                    $('.no-robot').removeClass('hidden');
                }
            });
            modal.open();
        });
    },

    paypal: function () {
        // PayPal
        paypalUtilsInit();
        paypalMFRAInit();
    },

    selectSavedPaymentInstrument: function () {
        $(document).on('click', '.saved-payment-instrument', function (e) {
            e.preventDefault();
            // $('.saved-payment-security-code').val('');
            $('.saved-payment-instrument').removeClass('selected-payment');
            $(this).addClass('selected-payment');
            $('.saved-payment-instrument .security-code-input').addClass('checkout-hidden');
            $('.saved-payment-instrument.selected-payment ' +
                '.security-code-input').removeClass('checkout-hidden');
            if (!$('.credit-card-form-custom').hasClass('checkout-hidden')) {
                $('.credit-card-form-custom').addClass('checkout-hidden');
                $('.add-payment').removeClass('checkout-hidden');
            }
            $('.payment-information').data('is-new-payment', false);
        });
    },

    addNewPaymentInstrument: function () {
        $('.add-payment').on('click', function (e) {
            e.preventDefault();
            $('.payment-information').data('is-new-payment', true);
            clearCreditCardForm();
            $('.credit-card-form-custom').removeClass('checkout-hidden');
            $('.user-payment-instruments .saved-payment-instrument.selected-payment').removeClass('selected-payment');
            $('.add-payment').addClass('checkout-hidden');
            $('.saved-security-code .security-code-input').addClass('checkout-hidden');
            $('body').trigger('checkout:addCreditCard');
        });
    },

    cancelNewPayment: function () {
        $('.cancel-new-payment').on('click', function (e) {
            e.preventDefault();
            $('.payment-information').data('is-new-payment', false);
            clearCreditCardForm();
            $('.user-payment-instruments').removeClass('checkout-hidden');
            $('.credit-card-form-custom').addClass('checkout-hidden');
        });
    },

    clearBillingForm: function () {
        $('body').on('checkout:clearBillingForm', function () {
            clearBillingAddressFormValues();
        });
    },

    paymentTabs: function () {
        $('.payment-options .nav-item').on('click', function (e) {
            e.preventDefault();
            var methodID = $(this).data('method-id');
            $('.payment-information').data('payment-method-id', methodID);
        });
    },

    handleApplyButton: function () {
        $('body').on('input', '#giftCardNumber, #giftCardPin', function (e) {
            var giftCardNumber = $('#giftCardNumber').val();
            var giftCardPin = $('#giftCardPin').val();
            if (giftCardNumber !== '' || giftCardPin !== '') {
                $('#giftCardFormGroup .buttonApplyGiftcard').removeClass('disabled');
            } else {
                $('#giftCardFormGroup .buttonApplyGiftcard').addClass('disabled');
            }
        });
    },

    setupHungarianVATValidation: function() {
        let localeElement = document.querySelector('#currentCountry');
        const locale = localeElement ? localeElement.getAttribute('data-country')?.toLowerCase() : null;
        if (locale !== 'hu') return;
        const billingInput = document.querySelector('#billingVATNumber');
        if (!billingInput) return;
        billingInput.addEventListener('input', function () {
            let rawValue = billingInput.value.replace(/\D/g, '').slice(0, 11);
            billingInput.value = rawValue;
            if (rawValue.length > 8) {
                billingInput.value = `${rawValue.slice(0, 8)}-${rawValue.slice(8, 9)}${rawValue.length > 9 ? '-' + rawValue.slice(9) : ''}`;
            }
        });
        const forbiddenNumbersElement = document.querySelector('#forbiddenNumbersData');
        if (!forbiddenNumbersElement) return;
        const forbiddenNumbers = forbiddenNumbersElement.dataset.values.split(',').map(num => num.trim());
        window.Parsley.addValidator('forbiddenVat', {
            validateString: function (value) {
                const cleanedValue = value.replace(/-/g, '').trim();
                return !forbiddenNumbers.includes(cleanedValue);
            }
        });
        $(billingInput).attr('data-parsley-forbidden-vat', '');
    }
};